import { render, staticRenderFns } from "./milk_volume.vue?vue&type=template&id=72e37762&scoped=true"
import script from "./milk_volume.vue?vue&type=script&lang=js"
export * from "./milk_volume.vue?vue&type=script&lang=js"
import style0 from "./milk_volume.vue?vue&type=style&index=0&id=72e37762&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e37762",
  null
  
)

export default component.exports